


































import { Component, Mixins, Prop, Watch, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { DataTableHeader } from "vuetify/types/index";
import AmchartLineGraph from "@/components/configuration/statistics/AmchartLineGraph.vue";
import {
  LineGraphData,
  LineData,
  CountData,
  DEFAULT_LINE_GRAPH_DATA,
  SearchObj,
} from "@/components/configuration/statistics/types";

/** ストレージ使用量グラフ情報 */
interface AgreementStorageGraph extends LineGraphData {
  /** ストレージ使用量情報 */
  lines: AgreementStorage[];
}

/** 1企業が持つストレージ使用量情報 */
interface AgreementStorage extends LineData {
  /** 凡例名 */
  title: string;
  /** 契約ID */
  agreement_id: number;
  /** 企業名 */
  company_name: string;
  /** 集計情報 */
  count_data: AgreementStorageCountData[];
}

/** 集計情報 */
interface AgreementStorageCountData extends CountData {
  /** 使用量 */
  count: number;
  /** yearmonth */
  yearmonth: number;
  /** yearmonth -> dateStr */
  date: string;
}

@Component({
  components: {
    AmchartLineGraph,
  },
})
export default class AgreementStorageViewer extends Mixins(
  AxiosMixin,
  UtilMixin
) {
  /** 検索条件 */
  @Prop() searchObj!: SearchObj;

  /** amchart操作用 */
  @Ref("amchart") private readonly amchart!: AmchartLineGraph;

  /** グラフデータ */
  private graphData: AgreementStorageGraph = DEFAULT_LINE_GRAPH_DATA;

  /** テーブルヘッダー情報 */
  private headers: DataTableHeader[] = [];

  /** テーブルデータ情報 */
  private items: unknown[] = [];

  /** Excel出力用情報 */
  private excelData: unknown[] = [];

  /** 初回時、検索ボタンクリック時に再描画させる */
  @Watch("searchObj")
  onChangeSearchObj() {
    this.fetchAgreementStorage();
  }
  /** 初回時、検索ボタンクリック時に再描画させる */
  created() {
    this.fetchAgreementStorage();
  }

  /** 与えられた検索条件を元に確定済みレセプト訪問記録の提出枚数を取得 */
  private async fetchAgreementStorage() {
    return new Promise((resolve) => {
      this.postJsonCheck(
        window.base_url + "/api/admin/agreement/storage/get",
        { ...this.searchObj },
        (res) => {
          this.graphData = {
            title: "ストレージ使用量",
            unit: "MB",
            lines: [],
          };

          this.graphData.lines = res.data.agreement_storages.map(
            (data: AgreementStorage) => {
              // yearmonthで並び替えた後、変換
              const countData = data.count_data
                .sort(function (a, b) {
                  if (a.yearmonth < b.yearmonth) return -1;
                  if (a.yearmonth > b.yearmonth) return 1;
                  return 0;
                })
                .map((count) => {
                  return {
                    count: count.count,
                    yearmonth: count.yearmonth,
                    date: this.convYearmonth2DateStr(count.yearmonth),
                  };
                });
              return {
                agreement_id: data.agreement_id,
                company_name: data.company_name,
                title: data.company_name,
                count_data: countData,
              };
            }
          );

          this.createHeaders();
          this.createItems();
          this.createExcelData();

          resolve(0);
        }
      );
    });
  }

  // Excel形式でエクスポート
  private exportData() {
    this.amchart.exportData();
  }

  /** data-table用ヘッダー生成 */
  private createHeaders() {
    // startとendからヘッダー情報を生成
    const startDt = this.newDate(
      this.convYearmonth2DateStr(this.searchObj.start_yearmonth) + "-01"
    );
    const endDt = this.newDate(
      this.convYearmonth2DateStr(this.searchObj.end_yearmonth) + "-01"
    );

    const resHeaders: DataTableHeader[] = [];
    resHeaders.push({
      text: "企業名",
      value: "agreement",
      align: "center",
      width: "100px",
      divider: true,
    });

    const current = startDt;
    let index = 0;
    while (current <= endDt) {
      resHeaders.push({
        text: this.dateToStr(current, "yyyy年MM月"),
        value: `yearmonth${index}`,
        align: "center",
        width: "80px",
        divider: true,
      });
      current.setMonth(current.getMonth() + 1);
      index++;
    }
    this.headers = resHeaders;
  }

  /** v-data-table用データ作成 */
  private createItems() {
    this.items = this.graphData.lines.map((data: AgreementStorage) => {
      const item: { [index: string]: unknown } = {
        agreement: data.company_name,
      };
      data.count_data.forEach((count, index) => {
        item[`yearmonth${index}`] = count.count;
      });
      return item;
    });
  }

  /** Excel出力用データ作成 */
  private createExcelData() {
    this.excelData = this.graphData.lines.map((data: AgreementStorage) => {
      const item: { [index: string]: unknown } = {
        企業名: data.company_name,
      };
      data.count_data.forEach((count) => {
        item[this.dateToStr(this.newDate(count.date + "-01"), "yyyy年MM月")] =
          count.count;
      });
      return item;
    });
  }

  /** yearmonth:number -> dateStr:string */
  private convYearmonth2DateStr(yearmonth: number): string {
    const yearmonthStr = String(yearmonth);
    return `${yearmonthStr.slice(0, 4)}-${yearmonthStr.slice(4, 7)}`;
  }
}
